<div>
    <mat-checkbox (change)="valueChanged($event)" [checked]="checked" [disabled]="disabled" (click)="handleClickOnCheckbox($event)">
        <mat-icon class="checkmark" *ngIf="checked">done</mat-icon>
        {{ label }}
    </mat-checkbox>
</div>
